import { NgModule } from '@angular/core';
import { AppApiModule } from '../services/api.module';
import { SharedModule } from '../shared/shared.module';

import { InsightsLibraryStateModule } from './insights-library-state.module';

import { InsightsLibraryCopiedSnack } from './components/snacks/copied.snack';
import { InsightsLibraryToggleHomeSnack } from './components/snacks/toggle-home.snack';

import { InsightsLibraryItemSelectorItemActionsDirective } from './components/item-selector/item-actions.directive';
import { InsightsLibraryItemSelectorItemDescriptionDirective } from './components/item-selector/item-description.directive';
import { InsightsLibraryItemSelectorItemPreviewDirective } from './components/item-selector/item-preview.directive';
import { InsightsLibraryItemSelectorComponent } from './components/item-selector/item-selector.component';
import { InsightsLibraryItemSelectorShellComponent } from './containers/item-selector-shell/item-selector-shell.component';

import { InsightsLibraryComponent } from './components/insights-library/insights-library.component';
import { InsightsLibraryShellComponent } from './containers/insights-library-shell/insights-library-shell.component';

import { InsightsLibraryDashboardsComponent } from './components/dashboards/dashboards.component';
import { InsightsLibraryInsightsComponent } from './components/insights/insights.component';
import { PbirModule } from '../pbir/PbirModule';


@NgModule({
  imports: [
    SharedModule,
    AppApiModule,
    InsightsLibraryStateModule,
    PbirModule
  ],
  declarations: [
    InsightsLibraryToggleHomeSnack,
    InsightsLibraryCopiedSnack,

    InsightsLibraryItemSelectorComponent,
    InsightsLibraryItemSelectorItemActionsDirective,
    InsightsLibraryItemSelectorItemDescriptionDirective,
    InsightsLibraryItemSelectorItemPreviewDirective,
    InsightsLibraryItemSelectorShellComponent,

    InsightsLibraryComponent,
    InsightsLibraryShellComponent,

    InsightsLibraryInsightsComponent,
    InsightsLibraryDashboardsComponent,
  ],
  exports: [
  ]
})
export class InsightsLibraryModule { }
